// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { MainSidebar } from '../components/mainsidebar'
import { SecSidebar } from '../components/secsidebar'
import { evalDateDay } from '../utils/enUtils.js'

export class Workforce extends Component {
    constructor(props) {
        super(props)

        this.state = {
            workers: [],
            workersTotal: null,
            workersCompleted: null,
            workersCompletionRate: null,
            workersInProgress: null,
            workersInProgressRate: null,
            workersNotStarted: null,
            workersNotStartedRate: null,
            activeModules: [],
            activeWorkerId: 0,
            activeWorkerName: "",
            activeModuleName: ""
        }

        this.init = this.init.bind(this)
        this.handleLoadWorkers = this.handleLoadWorkers.bind(this)
        this.handleActiveWorker = this.handleActiveWorker.bind(this)
        this.handleActiveModule = this.handleActiveModule.bind(this)

        this.init()
    }

    init() {
        if (!window.sessionStorage.getItem('authToken')) {
            this.props.router.push('/login')
            return
        }

        if (this.props.appData.authToken === '') {
            let storedData = window.sessionStorage

            let data = {
                profileType: storedData.profileType,
                loginStatus: storedData.loginStatus,
                authToken: storedData.authToken,
                id: storedData.uid,
                admin_first_name: storedData.fname,
                admin_last_name: storedData.lname,
                name: storedData.company,
                company: storedData.company,
                address: storedData.address,
                license_count: storedData.licenseCount,
                globalModules: JSON.parse(storedData.globalModules)
            }

            if (storedData.workers) {
                let workers = JSON.parse(storedData.workers)

                if ('activeModules' in storedData) {
                    this.state = {
                        workers: workers,
                        activeModules: JSON.parse(storedData.activeModules),
                        activeWorkerName: storedData.activeWorkerName,
                        activeWorkerId: storedData.activeWorkerId,
                        activeModuleName: storedData.activeModuleName
                    }
                }
                else {
                    this.state = {
                        workers: workers,
                        activeWorkerName: storedData.activeWorkerName,
                        activeWorkerId: storedData.activeWorkerId,
                        activeModuleName: storedData.activeModuleName
                    }
                }
            }

            this.props.handleProviderDataUpdateFromSessionStorage(data)
        }
    }

    evalRatingWorker(worker) {
        if (worker.average_strikes === null) {
            return "Not Started"
        }

        if (this.evalCompletedWorker(worker)) {
            switch (Math.round(worker.average_strikes)) {
                case 0: return 'Excellent'
                case 1: return 'Good'
                case 2: return 'Pass'
                case 3: return 'Poor'
                default: return 'Unknown Rating'
            }
        } else {
            return 'In Progress'
        }
    }

    evalCompletedWorker(worker) {
        let modulesCompleted = 0
        for (let i = 0; i < worker.enabler_modules.length; i++) {
            if (worker.enabler_modules[i].completed) {
                modulesCompleted++
            }
        }

        if (worker.enabler_modules.length > 0 && modulesCompleted === worker.enabler_modules.length) {
            return true
        } else {
            return false
        }
    }

    handleLoadWorkers(workers) {
        // Add extra data for workers
        workers.forEach((worker) => {
            worker.name = worker.first_name + " " + worker.last_name
            worker.rating = this.evalRatingWorker(worker)
            worker.completed = this.evalCompletedWorker(worker)
            worker.createdAtDate = evalDateDay(worker.created_at)
            worker.lastActiveDate = worker.last_active_at == null ? 'Never' : evalDateDay(worker.last_active_at)
        })

        // Calculate provider-wide completion rate figures
        let workersTotal = workers.length
        let workersCompleted = 0
        let workersCompletionRate = 0
        let workersInProgress = 0
        let workersInProgressRate = 0
        let workersNotStarted = 0
        let workersNotStartedRate = 0

        for (let i = 0; i < workers.length; i++) {
            if (workers[i].completed) {
                workersCompleted++
            }
            else if (workers[i].average_strikes !== null) {
                workersInProgress++
            }
            else {
                workersNotStarted++
            }
        }

        if (workersTotal > 0) {
            workersCompletionRate = Math.round(workersCompleted / workersTotal * 100.0)
            workersInProgressRate = Math.round(workersInProgress / workersTotal * 100.0)
            workersNotStartedRate = Math.round(workersNotStarted / workersTotal * 100.0)
        }

        this.setState({
            workers: workers,
            workersTotal: workersTotal,
            workersCompleted: workersCompleted,
            workersCompletionRate: workersCompletionRate,
            workersInProgress: workersInProgress,
            workersInProgressRate: workersInProgressRate,
            workersNotStarted: workersNotStarted,
            workersNotStartedRate: workersNotStartedRate,
        })

        window.sessionStorage.setItem("workers", JSON.stringify(workers))
    }

    handleActiveWorker(activeWorkerId) {
        let activeWorker = this.state.workers.filter(worker => worker.id === Number(activeWorkerId))[0]

        this.setState({
            activeModules: activeWorker.enabler_modules,
            activeWorkerName: activeWorker.first_name + " " + activeWorker.last_name,
            activeWorkerId: activeWorkerId
        })

        window.sessionStorage.setItem("activeModules", JSON.stringify(activeWorker.enabler_modules))
        window.sessionStorage.setItem("activeWorkerName", activeWorker.first_name + " " + activeWorker.last_name)
        window.sessionStorage.setItem("activeWorkerId", activeWorkerId)
    }

    handleActiveModule(moduleName) {
        this.setState({
            activeModuleName: moduleName
        })

        window.sessionStorage.setItem("activeModuleName", moduleName)
    }

    render() {
        let childWithProps = React.Children.map(this.props.children, child => {
            return (
                React.cloneElement(child, {
                    appData: this.props.appData,
                    env: this.props.env,
                    workers: this.state.workers,
                    workersTotal: this.state.workersTotal,
                    workersCompleted: this.state.workersCompleted,
                    workersCompletionRate: this.state.workersCompletionRate,
                    workersInProgress: this.state.workersInProgress,
                    workersInProgressRate: this.state.workersInProgressRate,
                    workersNotStarted: this.state.workersNotStarted,
                    workersNotStartedRate: this.state.workersNotStartedRate,
                    authToken: this.props.appData.authToken,
                    activeWorkerId: this.state.activeWorkerId,
                    activeWorkerName: this.state.activeWorkerName,
                    activeModuleName: this.state.activeModuleName,
                    activeModules: this.state.activeModules,
                    handleLoadWorkers: this.handleLoadWorkers,
                    handleActiveWorker: this.handleActiveWorker,
                    handleActiveModule: this.handleActiveModule
                })
            )
        })

        return (
            <div className="workforce-container page-container">
                <MainSidebar
                    profileType={this.props.appData.profileType}
                    logout={this.props.handleLoginStateChange}
                    profile={1}
                    appData={this.props.appData}
                />

                <SecSidebar
                    profileType={this.props.appData.profileType}
                    menuItemsKey={"workforce"}
                    profile={0}
                />

                <div className="main-body">
                    {childWithProps}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/workforce.js